// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3gfhj","itemTitle":"ClientEmergencyInfo_itemTitle__1GyWz","itemText":"ClientEmergencyInfo_itemText__3jxF7"};